"use strict";

history.pushState({
  page: document.referrer
}, "", window.location.pathname);
history.pushState({
  handle: window.location.pathname.replace("/products/", "")
}, "", window.location.pathname);
var initialProductPageHandle = window.location.pathname.replace("/products/", "");
window.addEventListener("popstate", e => {
  var _e$state, _e$state2;
  if ((_e$state = e.state) !== null && _e$state !== void 0 && _e$state.handle) {
    fetchStyle(e.state.handle);
  } else if ((_e$state2 = e.state) !== null && _e$state2 !== void 0 && _e$state2.page) {
    window.location.href = e.state.page;
  }
});
let colorQtys;
let colorQtyVariants;
let totalPackProds;
let prodUnavailable = false;
let openPopup = false;
let pdpSwiper = null;
function initCommonPackData() {
  colorQtys = document.querySelectorAll(".js-color-item .qty");
  colorQtyVariants = colorQtys.length ? Array.from(colorQtys).map(qty => {
    var _qty$dataset$options;
    const parent = qty.closest(".js-color-item");
    const infoBox = parent.querySelector(".color__info");
    const input = qty.querySelector("input[type=text]");
    const plusBtn = qty.querySelector("[data-action=plus]");
    const variants = (_qty$dataset$options = qty.dataset.options) === null || _qty$dataset$options === void 0 ? void 0 : _qty$dataset$options.split("_|_").map(item => {
      const parts = item.split("::");
      return {
        title: parts[0],
        id: parts[1],
        stock: Number(parts[2])
      };
    });
    return {
      parent: qty.closest(".js-color-item"),
      info: infoBox,
      input,
      plusBtn,
      variants
    };
  }) : null;
  totalPackProds = 0;
}
function initOptionSelectors(setAtbLabel, atbPrimary, atbTwoPack, isPack, days, lowStock, productActions, notifyBtn) {
  const options = document.querySelectorAll(".js-product-option");
  const masterSelector = document.querySelector(".js-main-master-select");
  const variants = Array.from(masterSelector.querySelectorAll("option"));
  const priceContainer = document.querySelector(".js-price-container");
  let twoPackMasterSelector = null;
  let twoPackVariants = null;
  if (atbTwoPack) {
    twoPackMasterSelector = document.querySelector(".js-two-pack-master");
    twoPackVariants = Array.from(twoPackMasterSelector.querySelectorAll("option"));
  }
  const selectedOptions = Array(options.length);
  const preOrder = document.querySelector(".product-default.pre-order");
  let packColorsActivated = false;
  const inputChangeHandler = (option, idx, input) => {
    productActions.classList.remove("--notify-active");
    if (input.checked) selectedOptions[idx] = input.value;
    const optionsString = selectedOptions.join("__");
    let available = false;
    const variantIndex = variants.findIndex(variant => variant.dataset.options === optionsString);
    atbPrimary.classList.remove("--notify");
    if (variantIndex < 0) {
      setAtbLabel("ua");
      if (isPack) prodUnavailable = true;
    } else if (variants[variantIndex].dataset.available !== "true" && !isPack) {
      setAtbLabel("oos");
      atbPrimary.classList.add("--notify");
      //productActions.querySelector("form input[name=variant_id]").value = variants[variantIndex].value;
      notifyBtn.setAttribute("data-option-value", input.value);
      notifyBtn.click();
    } else {
      if (!isPack) setAtbLabel("atb");
      masterSelector.selectedIndex = variantIndex;
      available = true;
    }
    if (!isPack) {
      const varQty = Number(variants[variantIndex].dataset.quantity);
      const lowStockEl = document.querySelector(".low-stock-info span");
      const lowStock = Number(lowStockEl.dataset.lowStock);
      if (varQty !== 0) {
        lowStockEl.innerText = varQty <= lowStock ? "".concat(varQty, " item").concat(varQty !== 1 ? "s" : "", " left") : "";
      } else {
        lowStock.innerText = "";
      }
    }
    if (variantIndex >= 0) {
      priceContainer.innerHTML = variants[variantIndex].dataset.price;
    }
    if (atbTwoPack) {
      atbTwoPack.classList.remove("--non-selected");
      const twoPackVariantIndex = twoPackVariants.findIndex(variant => variant.dataset.options === optionsString);
      if (twoPackVariantIndex < 0 || twoPackVariants[twoPackVariantIndex].dataset.available !== "true" || !available) {
        atbTwoPack.setAttribute("disabled", "disabled");
      } else {
        atbTwoPack.removeAttribute("disabled");
        twoPackMasterSelector.selectedIndex = twoPackVariantIndex;
      }
    }
    if (isPack && !packColorsActivated && Array.from(options).every(option => option.querySelector("input:checked"))) {
      var _document$querySelect;
      (_document$querySelect = document.querySelector(".product__colors")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.remove("--disabled");
      packColorsActivated = true;
    }
    if (isPack) {
      updateQtySelectors(optionsString, setAtbLabel, days, lowStock);
    }
  };
  const checkedOptionsHandlers = [];
  options.forEach((option, idx) => {
    const inputs = option.querySelectorAll("input");
    inputs.forEach(input => {
      input.addEventListener("change", () => {
        inputChangeHandler(option, idx, input);
      });
      if (input.checked) {
        checkedOptionsHandlers.push(() => {
          inputChangeHandler(option, idx, input);
        });
      }
    });
  });
  checkedOptionsHandlers.forEach(fn => fn());
  [{
    selector: masterSelector,
    btn: atbPrimary
  }, {
    selector: twoPackMasterSelector,
    btn: atbTwoPack
  }].forEach(item => {
    if (!item.btn) return;
    item.btn.addEventListener("click", e => {
      e.preventDefault();
      if (item.btn.getAttribute("disabled")) return;
      if (isPack) {
        addToCartPack(item.selector.value);
      } else {
        addToCartSingle(item.selector.value, 1, preOrder ? {
          _preOrder: true
        } : null);
      }
    });
  });
}
function initAdditionalProductSelectors() {
  const additionals = document.querySelectorAll(".item-product-simple");
  additionals.forEach(additional => {
    const masterSelector = additional.querySelector(".js-master-select");
    const variants = masterSelector.querySelectorAll("option");
    const atbBtn = additional.querySelector(".js-ajax-add-additional");
    const atbTwoPack = additional.querySelector(".js-ajax-two-pack-additional");
    let twoPackMasterSelector = null;
    let twoPackVariants = null;
    if (atbTwoPack) {
      twoPackMasterSelector = additional.querySelector(".js-two-pack-master-additional");
      twoPackVariants = twoPackMasterSelector.querySelectorAll("option");
    }
    [{
      data: variants,
      btn: atbBtn
    }, {
      data: twoPackVariants,
      btn: atbTwoPack
    }].forEach(item => {
      if (!item.data) return;
      const customSelector = document.createElement("div");
      customSelector.classList = "simple-item__custom-selector";
      item.data.forEach(variant => {
        const variantBox = document.createElement("div");
        const variantName = item.data.length > 1 ? variant.dataset.variantName : "ONE SIZE";
        if (variant.dataset.lowStock) {
          const quantity = Number(variant.dataset.quantity);
          variantBox.innerHTML = "".concat(variantName, " <span>").concat(quantity, " item(s) left</span>");
        } else if (variant.dataset.available !== "true") {
          variantBox.classList.add("--oos");
          variantBox.innerHTML = "".concat(variantName, " <span>Out of stock</span>");
        } else {
          variantBox.innerText = "".concat(variantName);
        }
        customSelector.append(variantBox);
        variantBox.addEventListener("click", () => {
          if (!variantBox.classList.contains("--oos")) {
            addToCartSingle(variant.value);
            openPopup = false;
          } else {
            const actions = variantBox.closest(".item__actions");
            const ty_message = actions.querySelector(".notify-bis form .ty_message");
            ty_message.innerText = "Thank you. We will email you when size ".concat(variantName, " is available.");
            actions.classList.add("--notify-active");
            actions.querySelector("form .email_label").innerText = variantName;
            actions.querySelector("form input[name=variant_id]").value = variant.value;
          }
          customSelector.classList.remove("--active");
        });
        item.btn.parentElement.append(customSelector);
      });
    });
    [atbBtn, atbTwoPack].forEach(btn => {
      btn === null || btn === void 0 ? void 0 : btn.addEventListener("click", e => {
        e.preventDefault();
        btn.nextElementSibling.classList.add("--active");
        openPopup = true;
      });
    });
  });
}
function initStyles(isPack) {
  const productTypes = document.querySelector(".product__types");
  if (productTypes) {
    let activeBtn = null;
    const colorBtns = productTypes.querySelectorAll("span");
    colorBtns.forEach(btn => {
      if (btn.classList.contains("--selected") || (isPack && btn.dataset.mainStyle)) activeBtn = btn;
      btn.addEventListener("click", () => {
        if (btn !== activeBtn) {
          if (!isPack) {
            fetchStyle(btn.dataset.handle);
            history.pushState({
              handle: btn.dataset.handle
            }, "", "/products/" + btn.dataset.handle);
          } else {
            fetchStyle(btn.dataset.handle, true);
          }
        } else if (isPack && btn.dataset.mainStyle) {
          var _packImage$nextElemen;
          document.querySelectorAll(".js-product-option").forEach(option => option.classList.remove("--disabled"));
          const packImage = document.querySelector(".product__images-item.--pack-image");
          if (packImage && packImage.nextElementSibling) {
            _packImage$nextElemen = packImage.nextElementSibling.querySelector("img");
            if (_packImage$nextElemen) _packImage$nextElemen.classList.remove("--img-loading");
          }
          if (packImage) packImage.parentElement.removeChild(packImage);
        }
        if (activeBtn) activeBtn.classList.remove("--selected");
        btn.classList.add("--selected");
        activeBtn = btn;
      });
    });
  }
}
function initSizeCharts() {
  const sizeOptionsTable = document.querySelector(".size-options-table");
  if (!sizeOptionsTable) return;
  const sizeOptions = Array.from(sizeOptionsTable.querySelectorAll("td label"));
  const sizes = sizeOptions.map(opt => opt.textContent);
  const cmChart = document.querySelector("#tab-size-cm table");
  const inChart = document.querySelector("#tab-size-in table");
  let sizeIndices = [];
  [{
    chart: cmChart,
    type: "cm"
  }, {
    chart: inChart,
    type: "in"
  }].filter(itm => itm.chart).forEach(_ref => {
    let {
      chart,
      type
    } = _ref;
    sizeIndices = [...sizes];
    const chartData = document.createElement("div");
    chart.querySelectorAll("tr").forEach((tr, ix) => {
      if (ix === 0) {
        tr.querySelectorAll("td").forEach((td, idx) => {
          const index = sizeIndices.indexOf(td.innerText);
          if (index >= 0) sizeIndices[index] = idx;
        });
        tr.parentElement.removeChild(tr);
      } else {
        const newTr = document.createElement("tr");
        const tdArr = Array.from(tr.querySelectorAll("td"));
        sizeIndices.unshift(0);
        sizeIndices.forEach(idx => newTr.append(tdArr[idx] || document.createElement("td")));
        chartData.append(newTr);
      }
    });
    chartData.setAttribute("data-unit", type);
    chartData.classList = "size-chart-holder";
    sizeOptionsTable.querySelector("tbody").append(chartData);
  });
  const sizeImage = document.querySelector(".size__image");
  const wrapper = sizeOptionsTable.parentElement;
  const activeClass = "--active";
  const firstLineHeight = sizeOptionsTable.querySelector("tr").offsetHeight;
  sizeOptionsTable.classList.add(activeClass);
  const wrapperOriginalHeight = wrapper ? wrapper.offsetHeight : 0;
  if (sizeImage) sizeOptionsTable.parentElement.append(sizeImage);
  let totalHeight = wrapper.offsetHeight;
  window.addEventListener("custom:chart-image-loaded", () => {
    if (!sizeImage) return;
    totalHeight = wrapperOriginalHeight + sizeImage.offsetHeight + 20;
  });
  const scTogglers = document.querySelector(".size-chart__togglers");
  if (scTogglers) {
    wrapper.style.height = "".concat(firstLineHeight, "px");
    wrapper.style.overflowY = "hidden";
    wrapper.classList.add("--animated-height");
  }
  if (scTogglers) {
    const sizeCharts = sizeOptionsTable;
    scTogglers.querySelector(".toggle").addEventListener("click", () => {
      scTogglers.classList.toggle(activeClass);
      if (wrapper.getAttribute("data-expanded")) {
        wrapper.style.height = "".concat(firstLineHeight, "px");
        wrapper.removeAttribute("data-expanded");
      } else {
        wrapper.style.height = "".concat(totalHeight, "px");
        wrapper.setAttribute("data-expanded", true);
      }
    });
    scTogglers.querySelectorAll(".unit span").forEach(el => {
      el.addEventListener("click", () => {
        sizeCharts.setAttribute("data-unit", el.dataset.value);
        el.parentElement.setAttribute("data-unit", el.dataset.value);
      });
    });
  }

  // setTimeout(() => {
  //   totalHeight = wrapper.scrollHeight;
  // }, 1500);
}

function initPackProducts(days, setAtbLabel) {
  const allInputs = Array.from(colorQtys).map(qty => qty.querySelector("input[type=text]"));
  allInputs.forEach(input => {
    const btns = input.parentElement.querySelectorAll("button");
    btns.forEach(btn => {
      btn.addEventListener("click", () => {
        var _input$closest;
        const currentValue = Number(input.value);
        if (btn.dataset.action === "minus" && currentValue > 0) {
          input.value = currentValue - 1;
        } else if (btn.dataset.action === "plus" && totalPackProds < days && currentValue < Number(btn.dataset.limit)) {
          input.value = currentValue + 1;
        }
        totalPackProds = allInputs.reduce((a, b) => a + Number(b.value), 0);
        setAtbLabel("pack", days - totalPackProds);
        const info = (_input$closest = input.closest(".js-color-item")) === null || _input$closest === void 0 ? void 0 : _input$closest.querySelector(".color__info");
        const left = info === null || info === void 0 ? void 0 : info.getAttribute("data-left");
        const willBeLeft = info === null || info === void 0 ? void 0 : info.getAttribute("data-will-be-left");
        if (info && left !== null && willBeLeft === null) {
          info.innerText = left - input.value === 0 ? "No more in stock" : "".concat(left - input.value, " item(s) left");
          input.classList.toggle("on-limit", left - input.value === 0);
        } else if (info && left !== null && willBeLeft !== null) {
          info.innerText = willBeLeft - input.value > left ? "" : willBeLeft - input.value === 0 ? "No more in stock" : "".concat(willBeLeft - input.value, " item(s) left");
          input.classList.toggle("on-limit", willBeLeft - input.value === 0);
        }
      });
    });
  });
  const allColorItems = Array.from(document.querySelectorAll(".js-color-item"));
  allColorItems.forEach(color_itm => {
    color_itm.addEventListener("click", () => {
      const img_idx = color_itm.getAttribute("data-image-index");
      if (img_idx !== null) {
        if (window.innerWidth >= 768) {
          const target_img = document.querySelector(".product__images-item:nth-child(".concat(img_idx, ")"));
          if (target_img) window.scrollBy({
            top: target_img.getBoundingClientRect().top,
            behavior: "smooth"
          });
        } else {
          pdpSwiper.slideTo(Number(img_idx) - 1);
        }
      }
    });
  });
}
function updateQtySelectors(masterVariant, setAtbLabel, days, lowStock) {
  let totalAvailable = 0;
  totalPackProds = 0;
  colorQtyVariants.forEach((qtyObj, i) => {
    const idx = qtyObj.variants.findIndex(qtyVariant => qtyVariant.title === masterVariant && qtyVariant.stock > 0);
    qtyObj.info.removeAttribute("data-left");
    if (idx < 0) {
      qtyObj.parent.setAttribute("data-oos", "true");
      qtyObj.info.innerText = "Out of stock";
      qtyObj.input.value = 0;
    } else {
      colorQtys[i].setAttribute("data-variant-id", qtyObj.variants[idx].id);
      totalAvailable += qtyObj.variants[idx].stock;
      qtyObj.parent.removeAttribute("data-oos");
      const stock = qtyObj.variants[idx].stock;
      const qtyDiff = stock - Number(qtyObj.input.value);
      // qtyObj.input.value = qtyDiff < 0 ? stock : qtyObj.input.value;
      qtyObj.input.value = 0;
      qtyObj.plusBtn.setAttribute("data-limit", qtyObj.variants[idx].stock);
      if (stock <= lowStock) {
        qtyObj.info.innerText = "".concat(stock, " item(s) left");
        qtyObj.info.setAttribute("data-left", stock);
      } else if (stock <= days) {
        qtyObj.info.setAttribute("data-left", lowStock);
        qtyObj.info.setAttribute("data-will-be-left", stock);
      } else {
        qtyObj.info.innerText = "";
      }
    }
    qtyObj.input.classList.remove("on-limit");
    totalPackProds += Number(qtyObj.input.value);
  });
  if (totalAvailable < days) {
    setAtbLabel("oos");
  } else {
    setAtbLabel(totalPackProds === 0 ? "Select your color(s)" : "pack", days - totalPackProds);
  }
}
function initProductPage(ignoreStyles, sizeSelected) {
  if (document.querySelector(".product--gift")) {
    initGiftAmountSelector();
    initGiftAddToBag();
    sliderMainImages();
    sliderPopupImages();
    initStickyScroll();
    return;
  }
  const isPack = document.querySelector(".product-default--pack");
  if (isPack) initCommonPackData();
  const days = isPack ? Number(isPack.dataset.days) : 0;
  const lowStock = isPack ? Number(isPack.dataset.lowStock) : 0;
  const notifyBtn = document.querySelector(".btn-notify-bis");
  const productActions = document.querySelector(".js-product__actions");

  // atb = "Add To Bag"
  const atbPrimary = document.querySelector(".js-ajax-add-primary");
  const atbTwoPack = document.querySelector(".js-ajax-two-pack");
  const preOrder = document.querySelector(".product-default.pre-order");
  function setAtbLabel(message, diff) {
    switch (message) {
      case "ua":
        atbPrimary.innerText = "Unavailable";
        break;
      case "oos":
        atbPrimary.innerText = "Out of stock";
        break;
      case "atb":
        atbPrimary.innerText = preOrder ? "Pre order" : "Add to bag";
        break;
      case "pack":
        diff === 0 ? setAtbLabel("atb") : atbPrimary.innerText = "Select ".concat(Math.abs(diff), " ").concat(diff > 0 ? "more" : "less");
        break;
      default:
        atbPrimary.innerText = message;
        break;
    }
    if (message === "atb") {
      atbPrimary.removeAttribute("disabled");
    } else if (message === "pack" && diff !== 0 || message !== "pack") {
      atbPrimary.setAttribute("disabled", "disabled");
    }
  }
  initOptionSelectors(setAtbLabel, atbPrimary, atbTwoPack, isPack, days, lowStock, productActions, notifyBtn);
  initAdditionalProductSelectors();
  if (!ignoreStyles) initStyles(isPack);
  initSizeCharts();
  sliderMainImages();
  sliderPopupImages();
  if (isPack) initPackProducts(days, setAtbLabel);
  initStickyScroll();
  if (ignoreStyles) reinitAccordions();
  let prevLabel = "";
  const options = Array.from(document.querySelectorAll(".js-product-option"));
  if (isPack) options.unshift(document.querySelector("[data-product-types]"));
  atbPrimary.addEventListener("mouseenter", () => {
    const unselected = options.find(option => {
      if (option.dataset.productTypes) {
        return !option.querySelector(".--selected");
      } else {
        return !option.querySelector("input:checked");
      }
    });
    if (unselected) {
      prevLabel = atbPrimary.innerText;
      setAtbLabel("Select a ".concat(unselected.dataset.productTypes ? "style" : unselected.dataset.optionName));
    } else {
      prevLabel = "";
    }
  });
  if (!isPack) {
    atbTwoPack === null || atbTwoPack === void 0 ? void 0 : atbTwoPack.addEventListener("mouseenter", () => {
      if (!atbTwoPack.classList.contains("--non-selected")) return;
      const unselected = options.find(option => {
        if (option.dataset.productTypes) {
          return !option.querySelector(".--selected");
        } else {
          return !option.querySelector("input:checked");
        }
      });
      if (unselected) {
        atbTwoPack.setAttribute("data-content", "Select ".concat(unselected.dataset.productTypes ? "Style" : "a ".concat(unselected.dataset.optionName)));
      }
    });
  }
  atbPrimary.addEventListener("mouseleave", () => {
    if (prevLabel) setAtbLabel(prevLabel);
  });
  if (!isPack) {
    notifyBtn.addEventListener("click", () => {
      productActions.classList.add("--notify-active");
      const label = notifyBtn.parentElement.querySelector("form .email_label");
      const ty_message = notifyBtn.parentElement.querySelector("form .ty_message");
      const labelText = options.map(option => {
        return "".concat(option.dataset.optionName, " ").concat(option.querySelector("input:checked").value);
      }).join(", ");
      label.innerText = "To be notified when ".concat(labelText, " becomes available, please enter your email below.");
      ty_message.innerText = "Thank you. We will email you when ".concat(labelText, " is available.");
    });
  }
  if (sizeSelected) {
    var _document$querySelect2;
    (_document$querySelect2 = document.querySelector(".size-options-table input[type=radio][value=".concat(sizeSelected, "]"))) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.click();
  }
  Array.from(document.querySelectorAll(".item-product-simple a.item__image")).forEach(item => {
    let clickreg = null;
    item.addEventListener("pointerdown", function (e) {
      var _window, _window$navigator;
      const plt = (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent;
      if (["iPhone", "iPad", "iPod"].some(item => plt.includes(item)) && !clickreg) {
        clickreg = {
          timeout: setTimeout(() => {
            clearTimeout(clickreg.timeout);
            clickreg = null;
          }, 150),
          pos: {
            x: e.clientX,
            y: e.clientY
          }
        };
      }
    });
    item.addEventListener("pointerup", function (e) {
      var _e$target$classList;
      if (e.target.closest(".slider-btn") || (_e$target$classList = e.target.classList) !== null && _e$target$classList !== void 0 && _e$target$classList.contains("slider-btn")) return;
      if (clickreg && e.clientX === clickreg.pos.x && e.clientY === clickreg.pos.y) {
        window.location.href = item.getAttribute("href");
      }
    });
  });
}
function initStickyScroll() {
  let equals = false;
  const content = document.querySelector(".product__content");
  const topContent = document.querySelector(".product__content-top");
  window.addEventListener("resize", () => {
    if (window.innerWidth < 768 && topContent.style.top !== "static") {
      topContent.style.top === "static";
    } else if (window.innerWidth >= 768 && !equals) {
      topContent.style.top === "sticky";
    }
  });
  if (window.innerWidth < 768) {
    return;
  }
  const additions = document.querySelector(".product__additions");
  let initialOffset = content.offsetTop;
  const watchBodyResize = new ResizeObserver(() => {
    if (window.scrollY > 0) {
      topContent.style.top = "".concat(content.offsetTop, "px");
    }
  });
  watchBodyResize.observe(document.body);
  let prevY = window.scrollY;
  topContent.style.position = "sticky";
  window.addEventListener("scroll", () => {
    const currY = window.scrollY;
    const contentTop = content.getBoundingClientRect().top;
    const topContentBottom = topContent.getBoundingClientRect().bottom;
    const topContentTop = topContent.getBoundingClientRect().top;
    const additionsTop = additions.getBoundingClientRect().top;
    if (currY > prevY) {
      if (additionsTop <= topContentBottom && additionsTop !== 0) {
        equals = true;
        content.style.justifyContent = "flex-end";
        topContent.style.position = "static";
      }
      if (topContentBottom > window.innerHeight && !equals) {
        topContent.style.top = "".concat(topContentTop - currY + prevY, "px");
      } else if (topContentBottom <= window.innerHeight && window.getComputedStyle(topContent).top === "auto") {
        topContent.style.top = "".concat(content.getBoundingClientRect().top + window.scrollY, "px");
      }
    } else {
      if (equals && (topContentTop > initialOffset || additionsTop > window.innerHeight)) {
        equals = false;
        topContent.style.position = "sticky";
        content.style.justifyContent = "space-between";
      }
      if (topContentTop < contentTop - window.scrollY && equals === false) {
        topContent.style.top = "".concat(topContentTop + prevY - currY, "px");
      }
    }
    prevY = window.scrollY;
    if (window.scrollY === 0) topContent.style.top = "auto";
  });
}
const eventOpenDrawer = new Event("custom:open-drawer");
async function addToCartSingle(id, qty, props) {
  await fetch("/cart/add.js", {
    headers: {
      "Content-Type": "application/json"
    },
    method: "POST",
    body: JSON.stringify({
      items: [{
        id: Number(id),
        quantity: qty ? qty : 1,
        properties: props
      }]
    })
  });
  window.dispatchEvent(eventOpenDrawer);
}
async function addToCartPack(id) {
  const props = {};
  Array.from(colorQtys).forEach(qty => {
    const input = qty.querySelector("input[type=text]");
    if (Number(input.value) > 0) {
      props["_Handle__".concat(qty.dataset.handle)] = "".concat(qty.dataset.variantId, "::").concat(input.value);
      props["".concat(qty.dataset.name)] = "x".concat(input.value);
    }
  });
  await fetch("/cart/add.js", {
    headers: {
      "Content-Type": "application/json"
    },
    method: "POST",
    body: JSON.stringify({
      items: [{
        id: Number(id),
        quantity: 1,
        properties: props
      }]
    })
  });
  window.dispatchEvent(eventOpenDrawer);
}
async function fetchStyle(handle, pack) {
  var _document$querySelect3;
  let sizeSelected = (_document$querySelect3 = document.querySelector(".size-options-table input[type=radio]:checked")) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.value;
  const imgItems = document.querySelector(".product__images .product__images-items");
  imgItems.parentElement.classList.add("--loader");
  imgItems.style.opacity = "0";
  const newPageData = await fetch("/products/".concat(handle, "?view=").concat(pack ? "pack-" : "", "ajax-do-not-assign&sections=product-default-").concat(pack ? "pack-" : "", "ajax"));
  const text = await newPageData.text();
  const parser = new DOMParser();
  const container = parser.parseFromString(JSON.parse(text)["product-default-".concat(pack ? "pack-" : "", "ajax")], "text/html");
  const styles = document.querySelector(".product__types");
  const newStyles = container.querySelector(".product__types");
  newStyles.parentElement.replaceChild(styles, newStyles);
  if (pack) {
    const textData = document.querySelector(".product__text-data");
    const newTextData = container.querySelector(".product__text-data");
    newTextData.parentElement.replaceChild(textData, newTextData);
  }
  const newContent = container.querySelector(".product-default");
  const oldContent = document.querySelector(".product-default");
  oldContent.parentElement.replaceChild(newContent, oldContent);
  window.scrollTo({
    top: 0
  });
  initProductPage(true, sizeSelected);
  setTimeout(() => {
    Array.from(newContent.querySelectorAll(".--img-loading")).forEach((item, idx) => {
      const rect = item.getBoundingClientRect();
      if (rect.top < window.innerHeight - 100 && rect > 0 || idx === 0) {
        item.classList.remove("--img-loading");
      }
    });
  }, 0);
}
window.addEventListener("unload", () => {
  window.scrollTo({
    top: 0
  });
});
function sliderMainImages() {
  const sliders = document.querySelectorAll(".slider-pdp-images");
  if (sliders == null) {
    return;
  }
  sliders.forEach(el => {
    const slider = el.querySelector(".swiper");
    const prev = el.querySelector(".slider-btn--prev");
    const next = el.querySelector(".slider-btn--next");
    const startIndex = el.getAttribute("data-start-index");
    const toggleButtons = state => {
      if (state) {
        el.classList.add("--hovered");
      } else {
        el.classList.remove("--hovered");
      }
    };
    el.addEventListener("mouseenter", () => toggleButtons(true));
    el.addEventListener("mouseleave", () => toggleButtons(false));
    el.addEventListener("touchstart", e => toggleButtons(true));
    el.addEventListener("touchend", e => toggleButtons(false));
    const swiper = new Swiper(slider, {
      speed: 800,
      slidesPerView: 1,
      initialSlide: startIndex ? Number(startIndex) - 1 : 0,
      loop: true,
      navigation: {
        prevEl: prev,
        nextEl: next
      }
    });
    if (el.classList.contains("--main-product-pdp")) {
      pdpSwiper = swiper;
    }
  });
}
function sliderPopupImages() {
  const sliderContainer = document.querySelector(".slider-popup-images");
  if (sliderContainer == null) {
    return;
  }
  const close = sliderContainer.querySelector(".slider__close");
  const wrapper = sliderContainer.querySelector(".swiper-wrapper");
  const closeSlider = () => {
    sliderContainer.classList.remove("is-active");
    document.querySelector("body").classList.remove("is-stopped");
  };
  close.addEventListener("click", closeSlider);
  if (wrapper) wrapper.addEventListener("click", () => {
    if (sliderContainer.classList.contains("is-active")) closeSlider();
  });
  const slider = sliderContainer.querySelector(".swiper");
  const prev = sliderContainer.querySelector(".slider-btn--prev");
  const next = sliderContainer.querySelector(".slider-btn--next");
  const swiper = new Swiper(slider, {
    speed: 600,
    slidesPerView: 1,
    loop: true,
    navigation: {
      prevEl: prev,
      nextEl: next
    }
  });
  const images = document.querySelectorAll(".js-popup-image-trigger");
  images.forEach(image => {
    image.addEventListener("click", function () {
      document.querySelector("body").classList.add("is-stopped");
      const index = parseInt(this.dataset.slideIndex, 10) - 1; // Asegúrate de que el índice comienza en 0
      sliderContainer.classList.add("is-active");
      swiper.slideTo(index, 0); // Opcional: 0 para cambiar sin animación
    });
  });
}
window.addEventListener("click", e => {
  var _e$target$closest;
  if (!openPopup) return;
  const exclusion = (_e$target$closest = e.target.closest(".item__add-btn")) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.querySelector(".simple-item__custom-selector");
  const actionsExclusion = e.target.closest(".item__actions");
  if (!e.target.closest(".simple-item__custom-selector")) {
    document.querySelectorAll(".simple-item__custom-selector").forEach(selector => {
      if (selector !== exclusion) selector.classList.remove("--active");
    });
    document.querySelectorAll(".item__actions").forEach(item => {
      if (item !== actionsExclusion) item.classList.remove("--notify-active");
    });
  }
});
function reinitAccordions() {
  document.querySelectorAll(".product-default .accordion-default").forEach(accordion => {
    const accordionTrigger = accordion.querySelector(".accordion__head");
    accordionTrigger.addEventListener("click", function () {
      const parent = this.parentNode;
      const isOpen = parent.classList.contains("is-open");
      parent.classList.toggle("is-open");
      const body = parent.querySelector(".accordion__body");
      if (isOpen) {
        body.style.height = "0px";
      } else {
        body.style.height = "".concat(body.scrollHeight, "px");
      }
      siblings(parent).forEach(sibling => {
        sibling.classList.remove("is-open");
        const body = sibling.querySelector(".accordion__body");
        body.style.height = "0px";
      });
    });
  });
}
function initGiftAmountSelector() {
  const selector = document.querySelector(".amount-selector__selector");
  const amountBox = document.querySelector(".amount-selector__amount");
  const amounts = Array.from(selector.querySelectorAll("span"));
  let preSelected = Number(selector.getAttribute("data-pre-selected"));
  if (isNaN(preSelected)) preSelected = 0;
  const parts = amounts.length;
  const toggle = selector.querySelector(".amount-selector__toggle");
  const getOffset = pos => {
    return pos === 0 ? " + 10px" : pos === parts - 1 ? " - 10px" : "";
  };
  if (parts) {
    toggle.style.left = "calc(".concat(100 * preSelected / (parts - 1), "%").concat(getOffset(preSelected), ")");
    let position = preSelected;
    let newPosition = preSelected;
    let portionLength = selector.offsetWidth / (parts - 1);
    let isDown = false;
    let prevX = null;
    let toggleLeft = toggle.getBoundingClientRect().left;
    let toggleRight = toggle.getBoundingClientRect().right;
    function togglePressed(e) {
      isDown = true;
      prevX = e.touches ? e.touches[0].clientX : e.clientX;
    }
    function toggleReleased() {
      if (isDown) {
        isDown = false;
        position = newPosition;
        toggle.style.left = "calc(".concat(newPosition * 100 / (parts - 1), "%").concat(getOffset(newPosition), ")");
        toggle.style.transform = "translate(-50%, -50%)";
        toggleLeft = toggle.getBoundingClientRect().left;
        toggleRight = toggle.getBoundingClientRect().right;
      }
    }
    function handleDrag(e) {
      if (!isDown) return;
      let cx = e.touches ? e.touches[0].clientX : e.clientX;
      let dx = cx - prevX;
      let sign = dx >= 0 ? 1 : -1;
      points = sign * Math.round(Math.abs(dx / portionLength));
      const toggleRect = toggle.getBoundingClientRect();
      const selectorRect = selector.getBoundingClientRect();
      if (toggleLeft + dx > selectorRect.left + 10 && toggleRight + dx < selectorRect.right - 10) {
        toggle.style.transform = "translate(calc(-50% + ".concat(dx, "px), -50%)");
      }
      let dp = position + points;
      if (dp >= 0 && dp < parts) {
        newPosition = dp;
      } else if (dp < 0) {
        newPosition = 0;
      } else {
        newPosition = parts - 1;
      }
      amountBox.innerText = amounts[newPosition].getAttribute("data-price");
      selector.setAttribute("data-variant-id", amounts[newPosition].getAttribute("data-variant-id"));
    }
    toggle.addEventListener("mousedown", togglePressed);
    toggle.addEventListener("touchstart", togglePressed);
    window.addEventListener("mouseup", toggleReleased);
    window.addEventListener("touchend", toggleReleased);
    window.addEventListener("mousemove", handleDrag);
    window.addEventListener("touchmove", handleDrag);
    selector.addEventListener("click", e => {
      if (isDown) return;
      const x = e.clientX;
      const left = selector.getBoundingClientRect().left;
      const dx = x - left;
      let newPosition = Math.round(dx / portionLength);
      newPosition = Math.min(parts - 1, Math.max(0, newPosition));
      toggle.style.left = "calc(".concat(newPosition * 100 / (parts - 1), "%").concat(getOffset(newPosition), ")");
      amountBox.innerText = amounts[newPosition].getAttribute("data-price");
      selector.setAttribute("data-variant-id", amounts[newPosition].getAttribute("data-variant-id"));
      position = newPosition;
    });
  }
}
function initGiftAddToBag() {
  const selector = document.querySelector(".amount-selector__selector");
  const btn = document.querySelector(".js-ajax-add-primary");
  const checkbox = btn.parentElement.querySelector("input[type=checkbox]");
  btn.addEventListener("click", e => {
    if (!checkbox.checked) {
      e.preventDefault();
      e.stopPropagation();
      checkbox.parentElement.classList.add("error-highlight");
      return;
    }
    addToCartSingle(selector.getAttribute("data-variant-id"));
  });
}
initProductPage();